// Require 30 continuous eligible seconds after a creative renders. Never catch
// up missed refreshes when returning from a hidden tab or a video ad break.
export function createDisplayRefresh({ eligible, refresh, now = () => performance.now() }) {
  let since = null;
  let ready = false;
  let stopped = false;
  return {
    rendered() { if (!stopped) { ready = true; since = null; } },
    tick() {
      if (stopped || !ready) return;
      if (!eligible()) { since = null; return; }
      const time = now();
      if (since === null) { since = time; return; }
      if (time - since < 30000) return;
      ready = false;
      since = null;
      refresh();
    },
    reset() { since = null; },
    stop() { stopped = true; ready = false; since = null; },
  };
}
